import React from 'react';
import image from './pic.png';
import './App.css';

function App() {
  return (
    <main className="app">
      <img src={image} alt="Preview" className="app__image" />
    </main>
  );
}

export default App;
